import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";
import FormInputError from "components/General/FormInputError";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

export default function MessageType({
  errors,
  setValue,
  control,
  setError,
  getValues,
  selectedOption,
  setSelectedOption,
}) {
  const dispatch = useDispatch();
  const { csrAlerts } = useSelector((s) => s.csrAlerts);
  const { t } = useTranslation();
  const [isToastMessageExist, setToastMessageExist] = useState(false);
  const [isBannerMessageExist, setisBannerMessageExist] = useState(false);

  useEffect(() => {
    const toastMessage = csrAlerts?.activeAlerts?.filter(
      (ac) => ac.group?.toLowerCase() === "toast"
    );
    if (toastMessage?.length > 0) {
      if (getValues("portal") === "both") {
        setToastMessageExist(true);
      } else {
        const toast = toastMessage?.find(
          (b) =>
            b.portal?.toLowerCase() === getValues("portal") ||
            b.portal?.toLowerCase() === "both"
        );
        setToastMessageExist(toast ? true : false);
      }
    }
    const bannerMessages = csrAlerts?.activeAlerts?.filter(
      (ac) => ac.group?.toLowerCase() === "banner"
    );

    if (bannerMessages?.length > 0) {
      if (getValues("portal") === "both") {
        setisBannerMessageExist(true);
      } else {
        let banner = bannerMessages.find(
          (b) =>
            b.portal?.toLowerCase() === getValues("portal") ||
            b.portal?.toLowerCase() === "both"
        );
        setisBannerMessageExist(banner ? true : false);
      }
    }
    if (selectedOption?.value === "toast") setValue("userView", "All pages");
    else if (selectedOption?.value === "banner")
      setValue("userView", "Login page");
    else if (selectedOption?.value === "companywide")
      setValue("userView", "Dashboard + Alerts & Documents");
  }, [getValues("portal")]);

  return (
    <div>
      <Controller
        name="group"
        control={control}
        render={() => (
          <RELEASING_AutoCompleteComboBox
            tooltipVerbiage={t("CsrAdminMessageType-tooltip-verbiage")}
            labelName="Message Type"
            inputPlaceholderText="Select"
            options={[
              {
                value: "",
                displayAs: "",
                selectedPolicyDisplayAs: "Select",
                isDisplayOnly: true,
              },
              {
                value: "toast",
                displayAs: "Toast",
                selectedPolicyDisplayAs: "Toast",
                isDisplayOnly: true,
                isInActive: isToastMessageExist,
              },
              {
                value: "banner",
                displayAs: "Banner",
                selectedPolicyDisplayAs: "Banner",
                isDisplayOnly: true,
                isInActive: isBannerMessageExist,
              },
              {
                value: "companywide",
                displayAs: "Company Wide",
                selectedPolicyDisplayAs: "Company Wide",
                isDisplayOnly: true,
              },
            ]}
            selectedOption={selectedOption}
            setSelectedOption={(option) => {
              if (option?.value) {
                setError("group", {
                  message: "",
                });
                setValue("group", option?.value);
                setSelectedOption({ value: option?.value });
                if (option?.value === "toast")
                  setValue("userView", "All pages");
                else if (option?.value === "banner")
                  setValue("userView", "Login page");
                else if (option?.value === "companywide")
                  setValue("userView", "Dashboard + Alerts & Documents");
              } else {
                setValue("group", "");
                setSelectedOption({ value: "" });
                setError("group", {
                  message: "This is a required field.",
                });
              }
            }}
          />
        )}
        rules={{
          required: "This is a required field.",
        }}
      />

      <FormInputError
        id={`portal-type-error`}
        errorMessage={errors?.messageType?.message}
      />
    </div>
  );
}
